import {registerTemplateGraphNode} from "#template/template-node/register"
import {z} from "zod/v4-mini"
import {TemplateGraphNode} from "#template/nodes/template-graph/template-graph-node"
import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"
import type {BuilderInlet} from "#template/runtime-graph/graph-builder"
import type {GraphBuilderScope} from "#template/runtime-graph/graph-builder-scope"
import type {NodeEvaluator} from "#template/node-evaluator"
import type {TemplateData} from "#template/compile-context"
import {LoadGraph} from "#template/runtime-graph/nodes/load-graph"

export type TemplateReferenceParameters = {
    templateId: number
    templateRevisionId: number | null
}

const templateReferenceDefinition: TemplateNodeDefinition<TemplateReferenceParameters> = {
    nodeClass: "TemplateReference",
    validation: {
        parameters: z.object({
            templateId: z.number(),
            templateRevisionId: z.nullable(z.number()),
        }),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class TemplateReference extends TemplateGraphNode<TemplateReferenceParameters> {
    public override get definition() {
        return templateReferenceDefinition
    }

    public override evaluate(scope: GraphBuilderScope, evaluator: NodeEvaluator): BuilderInlet<TemplateData | null> {
        return scope.struct<TemplateData>("TemplateData", {
            graph: scope.node(LoadGraph, {
                sceneManager: evaluator.templateContext.sceneManager,
                templateId: this.parameters.templateId,
                templateRevisionId: this.parameters.templateRevisionId,
            }).graph,
        })
    }
}
